import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50b0a330"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, null, -1))
const _hoisted_2 = [
  _hoisted_1
]




export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileButton',
  props: {
  click: {
    type: Function as PropType<() => void>,
    required: true
  },
  selected: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {

const props = __props;

const onClick = () => {
  props.click();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    onClick: onClick,
    class: _normalizeClass(["button-default header-button", { 'selected': __props.selected }])
  }, _hoisted_2, 2))
}
}

})